"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _log = require("@/utils/log");
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _user = require("@/api/user");
var _hike = require("@/api/hike");
var _lodash = _interopRequireDefault(require("lodash"));
var _cookie = require("@/utils/cookie");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import * as utils from '@/utils/auth'
// import { writeGaEvent } from '@/utils/ga'
var _default = exports.default = {
  name: 'HikeStaff',
  components: {
    draggable: _vuedraggable.default
  },
  props: {
    parentId: {
      type: String,
      default: ''
    },
    internalTitle: {
      type: String,
      default: ''
    },
    tenant: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loadingUsers: false,
      loadingRoles: false,
      keywordSearch: '',
      staffList: [],
      /* otr staff library */
      coachList: [],
      producerList: [],
      assistantList: [],
      raterList: [],
      clientPocList: [],
      oldClientPocList: [],
      haveLoop: false
    };
  },
  computed: {
    fullSelectedList: function fullSelectedList() {
      return _lodash.default.unionWith(this.coachList, this.assistantList, this.producerList, this.raterList, this.clientPocList);
    },
    loading: function loading() {
      return this.loadingUsers || this.loadingRoles;
    }
  },
  watch: {
    fullSelectedList: {
      handler: function handler(newVal) {
        // showDebugLog('Child-module emit to parent new value', newVal)
        this.passBackToParent(newVal);
      },
      deep: true
    },
    tenant: {
      handler: function handler(newVal) {
        if (newVal) {
          this.getStaffList();
        }
      }
    }
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.getStaffList();
          case 1:
            if (_this.parentId && _this.parentId !== 'copy') {
              _this.getStaffbyRole();
              _this.gethikeRelatedLoops(_this.parentId);
            }
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    /* no code */getStaffbyRole: function getStaffbyRole() {
      var _this2 = this;
      this.loadingRoles = true;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _hike.getHikeStaff)(token, this.parentId).then(function (response) {
        _this2.loadingRoles = false;
        _this2.coachList = response.data.rows.filter(function (row) {
          return row.role === 'coach';
        }).map(function (s) {
          return {
            role: s.role,
            user: s.user.uuid,
            name: "".concat(s.user.givenName, " ").concat(s.user.middleName, " ").concat(s.user.familyName),
            enrollmentQuota: s.enrollmentQuota
          };
        });
        _this2.assistantList = response.data.rows.filter(function (row) {
          return row.role === 'assistant';
        }).map(function (s) {
          return {
            role: s.role,
            user: s.user.uuid,
            name: "".concat(s.user.givenName, " ").concat(s.user.middleName, " ").concat(s.user.familyName),
            enrollmentQuota: s.enrollmentQuota
          };
        });
        _this2.producerList = response.data.rows.filter(function (row) {
          return row.role === 'producer';
        }).map(function (s) {
          return {
            role: s.role,
            user: s.user.uuid,
            name: "".concat(s.user.givenName, " ").concat(s.user.middleName, " ").concat(s.user.familyName),
            enrollmentQuota: s.enrollmentQuota
          };
        });
        _this2.raterList = response.data.rows.filter(function (row) {
          return row.role === 'rater';
        }).map(function (s) {
          return {
            role: s.role,
            user: s.user.uuid,
            name: "".concat(s.user.givenName, " ").concat(s.user.middleName, " ").concat(s.user.familyName),
            enrollmentQuota: s.enrollmentQuota
          };
        });
        _this2.clientPocList = response.data.rows.filter(function (row) {
          return row.role === 'client-poc';
        }).map(function (s) {
          return {
            role: s.role,
            user: s.user.uuid,
            name: "".concat(s.user.givenName, " ").concat(s.user.middleName, " ").concat(s.user.familyName),
            enrollmentQuota: s.enrollmentQuota
          };
        });
        _this2.oldClientPocList = _lodash.default.cloneDeep(_this2.clientPocList);
      }).catch(function (error) {
        _this2.loadingRoles = false;
        (0, _log.showDebugLog)('GetHikeStaff-api-error', error);
      });
    },
    getStaffList: function getStaffList() {
      var _this3 = this;
      this.loadingUsers = true;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var query = {
        page: 1,
        limit: 100,
        role: 'otr-coach,otr-product-admin,otr-digital-producer,client-staff',
        sort: 'givenName',
        q: this.keywordSearch
      };
      (0, _user.getUserList)(token, query).then(function (response) {
        // this.list = response.data.items
        _this3.loadingUsers = false;
        var rows = response.data.rows;
        if (_this3.tenant) {
          rows = rows.filter(function (s) {
            return s.metadata && s.metadata.tenants && s.metadata.tenants.includes(_this3.tenant);
          });
        }
        _this3.staffList = rows.map(function (s) {
          return {
            role: '',
            user: s.uuid,
            name: "".concat(s.givenName, " ").concat(s.middleName, " ").concat(s.familyName),
            sysRole: s.role
          };
        });
      }).catch(function (error) {
        _this3.loadingUsers = false;
        (0, _log.showDebugLog)('GetUserList-api-error', error);
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
      });
    },
    isDproducer: function isDproducer(sysRoleArray) {
      return _lodash.default.indexOf(sysRoleArray, 'otr-digital-producer') > -1;
    },
    cloneLibrary: function cloneLibrary(e) {
      return {
        role: e.role,
        user: e.user,
        name: e.name,
        sysRole: e.sysRole,
        enrollmentQuota: 0
      };
    },
    updateLibrary: function updateLibrary(evt) {},
    updateCoachList: function updateCoachList(evt) {
      this.coachList = _lodash.default.uniqBy(this.coachList, 'user');
      (0, _log.showDebugLog)('Hike-dragdrop-coach', evt);
      if (evt.added) {
        evt.added.element.role = 'coach';
      }
    },
    updateAssitantList: function updateAssitantList(evt) {
      this.assistantList = _lodash.default.uniqBy(this.assistantList, 'user');
      (0, _log.showDebugLog)('Hike-dragdrop-assistant', evt);
      if (evt.added) {
        evt.added.element.role = 'assistant';
      }
    },
    updateProducerList: function updateProducerList(evt) {
      this.producerList = _lodash.default.uniqBy(this.producerList, 'user');
      (0, _log.showDebugLog)('Hike-dragdrop-producer', evt);
      if (evt.added) {
        evt.added.element.role = 'producer';
      }
    },
    updateClientPocList: function updateClientPocList(evt) {
      this.clientPocList = _lodash.default.uniqBy(this.clientPocList, 'user');
      (0, _log.showDebugLog)('Hike-dragdrop-contact', evt);
      if (evt.added) {
        evt.added.element.role = 'client-poc';
      }
    },
    removeCoach: function removeCoach(idx, clist) {
      clist.splice(idx, 1);
    },
    removeAssistant: function removeAssistant(idx, alist) {
      alist.splice(idx, 1);
    },
    removeProducer: function removeProducer(idx, plist) {
      plist.splice(idx, 1);
    },
    removeClientPoc: function removeClientPoc(idx, clist) {
      clist.splice(idx, 1);
    },
    passBackToParent: function passBackToParent(staff) {
      if (staff) {
        this.$emit('updateParentStaff', staff);
      } else {
        this.$emit('updateParentStaff', []);
      }
    },
    sendEnrollmentToPOC: function sendEnrollmentToPOC() {
      var _this4 = this;
      // const haveClientPoc = this.oldClientPocList.filter(item => {
      //   let index = this.clientPocList.findIndex(v => {
      //     return item.user == v.user
      //   })
      //   return index !== -1
      // });
      // console.info(haveClientPoc.length)
      if (this.clientPocList.length > 0)
        // call api
        {
          var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
          (0, _hike.hikeNotifyHikeClientPOC)(token, this.parentId, {
            role: 'client-poc',
            action: 'send-enrollment-form'
          }).then(function (response) {
            _this4.$message({
              type: 'success',
              message: 'The enrollment form is successfully sent to Client POC by email.'
            });
          }).catch(function (error) {
            (0, _log.showDebugLog)('hikeNotifyHikeClientPOC-api-error', error);
            _this4.$message({
              type: 'error',
              showClose: true,
              duration: 5000,
              message: error.response.data.message
            });
          });
        } else {
        var msg = 'No Client POC is configured for this Hike. Please add it.';
        (0, _log.displayPopupMessage)(msg, 'error');
        return;
      }
    },
    gethikeRelatedLoops: function gethikeRelatedLoops(id) {
      var _this5 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loadingUsers = true;
      (0, _hike.hikeRelatedLoops)(token, id).then(function (response) {
        var d = response.data;
        _this5.haveLoop = d.count > 0;
        _this5.loadingUsers = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)('hike-hikeRelatedLoops-error', error);
        _this5.loadingUsers = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    }
  }
};